// extracted by mini-css-extract-plugin
module.exports = {"cus-mtdicon":"ij","cusMtdicon":"ij"};